import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productType'
})
export class ProductTypePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    switch(value){
     case 'INSTITUTION':
      return 'SWASTH CORPORATE'
     case 'LOYALTY':
      return 'SWASTH'
     case '':
      return '--'
     default:
      return value
    }
  }
}